async function getCepData(cep) {
    try {
        // Remove qualquer caractere não numérico do CEP
        const cleanCep = cep.replace(/\D/g, '');
        
        // Faz a requisição para a API ViaCEP
        const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json`);
        
        // Verifica se a resposta foi bem-sucedida
        if (!response.ok) {
            throw new Error(`Erro na consulta do CEP: ${response.status}`);
        }
        
        // Retorna os dados em formato JSON
        return await response.json();
    } catch (error) {
        throw error;
    }
}

export { getCepData }
